import React, { FC } from "react";
import ResourceItem from "../resource-item";
import styles from "./resourceList.module.scss";

interface ResourceListProps {
  resources: any[];
}

const ResourceList: FC<ResourceListProps> = ({ resources }) => {
  return (
    <div className={styles.resourceList}>
      {resources.map((resource, _index) => (
        <ResourceItem data={resource.self} key={`${resource.key}-${_index}`} />
      ))}
    </div>
  );
};

export default ResourceList;
